module.exports = __webpack_public_path__ + "assets/img/2february_light.0c51ac23.jpeg";